import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React, { ReactNode, useRef } from 'react'
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { styled } from '@mui/material/styles';


interface tileContainerProps {
    children?: ReactNode
    title: string
    styles: string
    icon: ReactNode
    titleColor: string
    secondaryIcon?: ReactNode
    infoArray?: { title: string, body: string }[]
}


const SettingsBlock: React.FC<tileContainerProps> = ({ secondaryIcon, children, title, icon, styles, titleColor, infoArray }) => {



    return (
        <div className={`${styles} 	 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] w-full h-full p-5   gap-3`}>
            <div className={` flex items-center  justify-between ${titleColor}   `}>
                <div className='flex gap-[2px] items-center'>
                    {icon}
                    <div className={`font-bold uppercase pb-[0.5px]  inline-block relative `}>
                        {title}
                        <div style={{ backgroundColor: `${titleColor.split("-")[1].replace(/\[|\]/g, '')}` }} className={`w-7 h-[3px] absolute bottom-0 left-[0.6px]  `}>
                        </div>
                    </div>
                    <CustomWidthTooltip arrow title={
                        <div className='flex flex-col gap-3 p-3'>
                            {infoArray?.map((node) => {
                                return <p className='h-max text-[15px]'>
                                    <span className='font-bold'>{node?.title}</span>
                                    {node?.body}
                                </p>
                            })}
                        </div>}>

                        <div className=' ml-3 text-primary'>
                            <InfoOutlinedIcon />
                        </div>
                    </CustomWidthTooltip>
                </div>

            </div>
            {children}
        </div >
    )
}

export default SettingsBlock


export const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 600,
        backgroundColor: "var(--theme-primary)",
        color: "#ffffff",
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "var(--theme-primary)",
    },
});